import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {articles,article,categorys,category,threenum,livestreamConfig} = api

/**
 * 查找
 */
export async function findArticles(params) {
    return request({url: articles, method: 'get', data: params,})
}
/**
 * 查找文章详情
 */
export async function findArticle(params) {
    return request({url: article, method: 'get', data: params,})
}
/**
 * 删除文章详情
 */
export async function deleteArticle(params) {
    return request({url: article, method: 'delete', data: params,})
}
/**
 * 创建编辑文章
 */
export async function createOrEditArticles(params) {
    return request({url: articles, method: 'post', data: params,})
}
/**
 * 查找分类
 */
export async function findCategorys(params) {
    return request({url: categorys, method: 'get', data: params,})
}
/**
 * 创建更新分类
 */
export async function createOrUpdateCategorys(params) {
    return request({url: categorys, method: 'post', data: params,})
}
/**
 * 删除分类
 */
export async function deleteCategory(params) {
    return request({url: category, method: 'delete', data: params,})
}
/**
 * 查找数据
 */
export async function findThreenum(params) {
    return request({url: threenum, method: 'get', data: params,})
}
/**
 * 查找数据
 */
export async function updateThreenum(params) {
    return request({url: threenum, method: 'put', data: params,})
}
/**
 * 查找直播
 */
export async function findLivestreamConfig(params) {
    return request({url: livestreamConfig, method: 'get', data: params,})
}
export async function updateLivestreamConfig(params) {
    return request({url: livestreamConfig+'?enable='+params.enable, method: 'put', data: params,})
}





// WEBPACK FOOTER //
// ./src/services/website.js